/**
 * Formatters for the DRE audit panel.
 *
 * Diff computation lives on the backend now (see `compute-changes.ts`). The
 * snapshot stores only items that changed; the frontend just renders them.
 */

import type { CachePeriod } from '../../hooks/useDreAudit'

export function periodKey(p: CachePeriod): string {
  return `${p.year}-${String(p.month).padStart(2, '0')}`
}

const MONTH_LABEL = ['', 'jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']
export function formatPeriodShort(p: CachePeriod): string {
  return `${MONTH_LABEL[p.month] ?? '?'}/${String(p.year).slice(-2)}`
}

export function formatBRL(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—'
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}

export function signedBRL(value: number): string {
  const sign = value > 0 ? '+' : ''
  return `${sign}${formatBRL(value)}`
}

export function formatPct(pct: number | null): string {
  if (pct === null) return '—'
  const sign = pct > 0 ? '+' : ''
  return `${sign}${pct.toFixed(1)}%`
}

/** Returns null when before is 0 (avoid division by zero). */
export function pctChange(before: number, after: number): number | null {
  if (before === 0) return null
  return ((after - before) / before) * 100
}

export function deltaColor(delta: number): string {
  if (delta === 0) return 'text-brand-gray'
  return delta > 0 ? 'text-success' : 'text-error'
}
